// Local ambient declaration: the library's tsconfig pins `types` to a small list
// that excludes @types/node, so `process` is otherwise unknown to tsc. Declaring
// it here (module-scoped, type-only) keeps the literal `process.env.NODE_ENV`
// member access that bundlers statically replace, without leaking node globals
// into the published type surface.
declare const process: { env: { NODE_ENV?: string } };

/**
 * True in development and test, false in production. Bundlers (Vite, webpack)
 * replace `process.env.NODE_ENV` at build time, so dev-only diagnostics guarded
 * by this drop out of production bundles. When the environment cannot be
 * determined the quiet choice (no warnings) is taken.
 */
export function isDevEnv(): boolean {
  if (typeof process === 'undefined') return false;
  return process.env.NODE_ENV !== 'production';
}

/** Emit a `[Table]`-prefixed warning in development only. Never throws. */
export function devWarn(message: string): void {
  if (isDevEnv()) console.warn(`[Table] ${message}`);
}
